/* eslint-disable spire/export-styles */
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    contactNum = "contactNum",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.contactNum]: string;
    };
}

export interface ContactNumberStyles {
    link: InjectableCss;
}

export const contactStyles: ContactNumberStyles = {
    link: {
        css: css`
            margin-left: 20px;
            font-weight: 600;
        `,
    },
};

type Props = OwnProps;

const styles = contactStyles;

const ContactNumber: React.FunctionComponent<Props> = ({ fields }: Props) => {
    if (!fields.contactNum || !Number(fields.contactNum) || fields.contactNum.length !== 10) {
        return null;
    }

    return (
        <span data-test-selector="video">
            <Link href={`tel:${fields.contactNum}`} {...styles.link}>
                {fields.contactNum.replace(/^(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")}
            </Link>
        </span>
    );
};

const widgetModule: WidgetModule = {
    component: ContactNumber,
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.contactNum,
                editorTemplate: "TextField",
                displayName: "Contact Number",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
